import React, { FunctionComponent } from 'react';

// MUI
import Box from '@mui/material/Box';

// Custom
import AppPage from '@/ui/AppPage/AppPage';
import Permissions from '@/lib/permissions';
import ZalbeTable from './ZalbeTable';

const ZalbePage: FunctionComponent = () => {

  const pageTitleToken = "ena:page.zalbe";

  return (
    <AppPage
      titlett={pageTitleToken}
      needPermission={[Permissions.EnaViewNekretnine]}
    >
      <Box m={0} style={{ height: '100%' }}>
        <ZalbeTable />
      </Box>
    </AppPage>
  );
}

export default ZalbePage;
